import pumiFiClass from "src/data/pumiFi/pumiFiClass";
import mailClass from "../system/mailClass";
import { confirmStepLogType, newStepLogMessage } from "../stepLog/stepLogMessageClass";
import { v4 as uuidv4 } from "uuid";
import stat from "src/components/js/stat";
import { parseJSONDate, pvmString } from "src/components/js/statics1";
import SMSClass from "../SMSClass";
import { sendNotificationsToKeikkaUsers } from "./changeHandler";
import { sendMessageToPersonDevices } from "../system/firebaseClass";
import { keikka_foreignKey_save_to_db } from "./KeikkaFunctions";
import { socketOnSave } from "../system/socketClass";

// kun asiakas lähettää tilauksen
// 1. laita keikkaTilaId = 2: odottaa vastaanottajaa
// 2. sendTilausToive: lähettää saapuva tilaus ilmoitukset pumpputoimittajalle
//        sähköposti, TODO:ilmoitus
// 3. add stepLog message: stepLogTypeId = 1: tilaus lähetetty
// 4. asiakascheckboxes: ilmoitukset kun tapahtuu jotain
// 5. lähetä saapuva tekstiviesti pumppuToimittaja.asiakasContactPersonPhone
// If Kalle Urho -> Luo pumi.fi saapuva palkka
export async function kunCustomerSendsOrder(
  keikkaData,
  personId,
  token,
  isTarjouspyyntö = false,
  ilmoituksetKunMuutos = false,
  socket
) {
  const thisMail = new mailClass(keikkaData);
  thisMail.confirmCode = uuidv4();
  thisMail.setButtonUrl();
  await laitaKeikkaTilaIdOdottaaVastaanottajaa(keikkaData, personId, token, isTarjouspyyntö);
  await sendNotificationsToToimittajat(keikkaData, personId, token, isTarjouspyyntö, thisMail);
  await sendNotificationsToUsers(keikkaData, personId, token);
  await doAddStepLogMessages(keikkaData, personId);
  await handleAsiakasCheckbox(keikkaData, personId, ilmoituksetKunMuutos, isTarjouspyyntö, socket);
  await luoPumiFiSaapuvaPalkki(keikkaData, personId, token, isTarjouspyyntö, socket);
  await finalizeOrderSend(keikkaData);

  async function laitaKeikkaTilaIdOdottaaVastaanottajaa(keikkaData, currentPersonId, token) {
    // 1. laita keikkaTilaId: odottaa vastaanottajaa
    keikkaData.tila.keikkaTilaId = 2;
    await keikkaData.tila.saveKeikkaTilaToDB(
      currentPersonId,
      token,
      false,
      null,
      keikkaData.varmenne
    ); //do not send socket onSave to all clients
  }
  async function sendNotificationsToToimittajat(
    keikkaData,
    currentPersonId,
    token,
    isTarjouspyyntö,
    thisMail
  ) {
    // 2 Send saapuva tilaus ilmoitukset pumpputoimittajalle
    // 2.1 sähköposti
    if (isTarjouspyyntö) thisMail.sendTarjouspyyntö(token);
    else thisMail.sendTilausToive(token); // maybe await if we need to get result, or a .then
    // 2.2 SMS
    const SMSToPuh = mailClass.getMSISDN(keikkaData.pumppuToimittaja.asiakasContactPersonPhone);
    let SMSTxt = "BetoniOnline tilaus:\n" + keikkaData.smsString + "\n\r terv: betoniOnline";
    if (isTarjouspyyntö)
      SMSTxt = "BetoniOnline tarjouspyyntö:\n" + keikkaData.smsString + "\n\r terv: betoniOnline";
    const sms = new SMSClass(keikkaData, currentPersonId, token);
    sms.sendSMS(SMSToPuh, SMSTxt, socket);
  }
  async function sendNotificationsToUsers(keikkaData, currentPersonId, token) {
    // 2.3 ilmoitus / notification
    const notification = {
      title: "Saapuva tilaus",
      body: "Saapuva tilaus: " + keikkaData.smsString,
      url: "/tilaus/" + keikkaData.keikkaId,
      keikkaId: keikkaData.keikkaId,
      personId: currentPersonId,
      icon: "/img/pumi.png",
      keikkaString: keikkaData.keikkaStringShort,
      ttl: calcTTL_s(keikkaData),
      collapseKey: keikkaData.keikkaId,
      priority: "normal",
    };
    await sendMessageToPersonDevices(
      notification.title,
      notification.body,
      keikkaData.pumppuToimittaja.asiakasContactPersonId,
      keikkaData.keikkaId,
      token,
      keikkaData.keikkaId
    );
    sendNotificationsToKeikkaUsers(notification, socket);
  }
  async function doAddStepLogMessages(keikkaData, currentPersonId) {
    // 3. addStepLog message
    const _t = isTarjouspyyntö ? "Tarjouspyyntö" : "Tilaus";

    const sl = newStepLogMessage(
      _t + " lähetetty osoiteeseen " + thisMail.emailToEmail,
      currentPersonId,
      keikkaData,
      1
    );
    sl.isSystemMessage = true;
    sl.requireConfirm = true;
    sl.confirmCode = thisMail.confirmCode;
    sl.saveToDB(socket, false); // do not send stepLogUpdate to all clients

    const sl2 = newStepLogMessage(
      _t + " on lähetetty, odottaa vastaanottajaa.",
      currentPersonId,
      keikkaData,
      1
    );
    sl2.requireConfirm = true;
    sl2.saveToDB(socket, false); // do not send stepLogUpdate to all clients
  }
  async function handleAsiakasCheckbox(
    keikkaData,
    currentPersonId,
    ilmoituksetHenkilölleKunTapahtuuJotain,
    isTarjouspyyntö,
    socket
  ) {
    // 4. asiakascheckboxes: ilmoitukset kun tapahtuu jotain
    if (!isTarjouspyyntö && ilmoituksetHenkilölleKunTapahtuuJotain) {
      const sl = newStepLogMessage(
        "Ilmoitukset asiakkaalle kun tehdään muutoksia",
        currentPersonId,
        keikkaData,
        23
      );
      // save to db and emit socket
      await sl.saveToDB(socket, false);
    }
  }
  async function luoPumiFiSaapuvaPalkki(
    keikkaData,
    currentPersonId,
    token,
    isTarjouspyyntö,
    socket
  ) {
    // If Kalle Urho (asiakasId=8)
    // Luo pumi.fi saapuva keikka palkki
    if (
      !isTarjouspyyntö &&
      (keikkaData.pumppuToimittaja.asiakasId === 8 || keikkaData.pumppuToimittaja.asiakasId === 62)
    ) {
      // create pumi.fi saapuva keikka
      const keikkaId_v2 = await pumiFiClass.createPumiFiSaapuvaKeikka(keikkaData, token);
      keikkaData.foreignKey = keikkaId_v2;
      keikka_foreignKey_save_to_db(keikkaData, token);
      const sl4 = newStepLogMessage(
        "Saapuva keikka pumi.fi palkki luotu",
        currentPersonId,
        keikkaData,
        7
      );
      sl4.isSystemMessage = true;
      sl4.saveToDB(socket, false);
    }
  }
  async function finalizeOrderSend(keikkaData) {
    // varmista edell
    confirmStepLogType(keikkaData.keikkaId, 16, socket, false); // confirm type 16 = "Tilaus täytetty, odottaa lähetystä"
    socket.emit("stepLog:update", keikkaData.keikkaId, true); // SEND stepLogUpdate to all clients

    // send socket event
    const s = new socketOnSave(
      personId,
      socket,
      keikkaData.ownerAsiakasId,
      "keikkaData",
      "save",
      keikkaData.keikkaId
    );
    s.keikkaData = keikkaData;
    s.emitSave();
  }
}

export async function deleteKeikka(keikkaData, personId, token, socket) {
  keikkaData.tila.keikkaTilaId = 10;
  await keikkaData.tila.saveKeikkaTilaToDB(personId, token, true, null, keikkaData.varmenne);
  keikkaData.auth.edit = false;
  keikkaData.asiakas.auth.edit = false;
  const sl2 = newStepLogMessage("Tilaus poistettu", personId, keikkaData, 10);
  // save to db and emit socket
  await sl2.saveToDB(socket, true);
  const notificationData = {
    title: "Tilaus poistettu : " + keikkaData.keikkaId,
    body: "Tilaus poisettu",
    url: "/tilaus/" + keikkaData.keikkaId,
    keikkaId: keikkaData.keikkaId,
    personId: personId,
    icon: "/img/pumi.png",
    keikkaString: keikkaData.keikkaStringShort,
    ttl: calcTTL_s(keikkaData),
    collapseKey: keikkaData.keikkaId,
    priority: "normal",
  };
  sendNotificationsToKeikkaUsers(notificationData, socket);
}
const defaultTTL = 2 * 60 * 60;

/**
 * Calculates the time-to-live (TTL) for a keikkaData object.
 * @param {Object} keikkaData - The keikkaData object.
 * @returns {number} The TTL in seconds.
 */
function calcTTL_s(keikkaData) {
  const ttl_s = Math.max(
    Math.floor((keikkaData.pumppu.pumppuAika - Date.now()) / 1000),
    defaultTTL
  );
  return ttl_s;
}

// kun pumppuyritys/betonitoimija vastaanottaa tilauksen
// 1. Laita stepLog "Tilaus vastaanotettu"
// 2. Lisää stepLog hyväksynnät: aika, tyomaa, asiakas, pumppu, betoni, m3
// 3. Poista ilmoitukset
// 4. Laita keikkaTilaId = 3: tilaus vastaanotettu
export async function kunPumppuToimittajaVastaanottaaTilauksen(
  keikkaData,
  personId,
  token,
  socket
) {
  // confirm type 1 = "Tilaus lähetetty, odottaa vastaanottajaa"
  confirmStepLogType(keikkaData.keikkaId, 1, socket, false);
  // confirm type 2 = "on vastaanottanut tilauksen"
  confirmStepLogType(keikkaData.keikkaId, 2, socket, false);
  // aseta keikkaTilaId = 3: tilaus vastaanotettu
  keikkaData.tila.keikkaTilaId = 3;
  await saveKeikkaTilaToDB_exported(keikkaData, personId, token, socket);

  const sl = newStepLogMessage(
    "Tilaus on siirretty " + keikkaData.pumppuToimittaja.asiakasNimi + ":n käsiteltäväksi",
    personId,
    keikkaData,
    2,
    keikkaData.pumppuToimittaja.asiakasId
  );
  sl.data = keikkaData.pumppuToimittaja.asiakasId;
  sl.isConfirmed = true;
  sl.confirmDate = new Date();
  sl.saveToDB(socket, true);

  // Hyväksytään automaattisesti jos isImported (foreignKey!=undefined)
  let _aikaMsg =
    "Hyväksy toimitusaika: " +
    pvmString(parseJSONDate(keikkaData.pumppu.pumppuAika)) +
    " klo:" +
    keikkaData.pumppu.pumppuAikaStringLong +
    " " +
    keikkaData.pumppu.pumppuString +
    " " +
    keikkaData.pumppu.linjaString;
  let _aikaBool = false;
  if (keikkaData.foreignKey !== undefined) {
    _aikaMsg =
      "Toimitusaika hyväksytty, tilaus tuotu ulkoiseta järjestelmästä: " + keikkaData.foreignKey;
    _aikaBool = true;
  }

  const sl2 = newStepLogMessage(_aikaMsg, personId, keikkaData, 17);
  sl2.isSystemMessage = true;
  sl2.requireConfirm = true;
  sl2.isConfirmed = _aikaBool;
  sl2.saveToDB(socket, true);

  // #region Työmaan ja asiakkaan hyväksyntä
  // haetaan asiakkaan tilauksien lukumäärät
  // mikäli on ensimmäinen toimitus työmaalle
  const a = await stat.getCounts(
    0,
    keikkaData.tyomaa.tyomaaId,
    keikkaData.pumppuToimittaja.asiakasId,
    0,
    token
  );
  if (a.length == 1) {
    const sl3 = newStepLogMessage(
      "Työmaalle ei ole toimitettu aikaisemmin, tarkista että työmaa on toimitusaluellasi: " +
        keikkaData.tyomaa.tyomaaOsoiteString,
      personId,
      keikkaData,
      18
    );
    sl3.isSystemMessage = true;
    sl3.requireConfirm = true;
    sl3.isConfirmed = false;
    sl3.saveToDB(socket, true);
  } else {
    const sl3 = newStepLogMessage(
      "Työmaa hyväksytty: " + (a.length - 1) + " aikaisempaa tilausta",
      personId,
      keikkaData,
      18
    );
    sl3.isSystemMessage = true;
    sl3.requireConfirm = false;
    sl3.isConfirmed = true;
    sl3.confirmDate = new Date();
    sl3.saveToDB(socket, true);
  }
  // haetaan asiakkaan tilauksien lukumäärät
  // mikäli on ensimmäinen toimitus asiakkaalle
  const b = await stat.getCounts(
    keikkaData.asiakas.asiakasId,
    0,
    keikkaData.pumppuToimittaja.asiakasId,
    0,
    token
  );
  if (b.length == 1) {
    const sl4 = newStepLogMessage(
      "Uusi asiakas, tarkista ja hyväksy asiakastiedot: " + keikkaData.asiakas.asiakasNimi,
      personId,
      keikkaData,
      19
    );
    sl4.isSystemMessage = true;
    sl4.requireConfirm = true;
    sl4.isConfirmed = false;
    sl4.saveToDB(socket, true);
  } else {
    const sl4 = newStepLogMessage(
      "Asiakas hyväksytty: " + (b.length - 1) + " aikaisempaa tilausta",
      personId,
      keikkaData,
      19
    );
    sl4.isSystemMessage = true;
    sl4.requireConfirm = false;
    sl4.isConfirmed = true;
    sl4.confirmDate = new Date();
    sl4.saveToDB(socket, true);
  }
  // poista ylimääräiset stepLogit
  // #endregion
}

// kun pumppuyritys hyväksyy tilauksen
// Kun keikkaAdmin hyväksyy tilauksen
// Tee notifikaatiot ja stepLog
export async function kunPumppuToimittajaHyväksyyTilauksen(keikkaData, personId, token, socket) {
  // ensin vastaanota tilaus, sitten hyväksy
  await kunPumppuToimittajaVastaanottaaTilauksen(keikkaData, personId, token, socket);

  // laita keikkaTilaId = 4: Toimitusvalmis
  keikkaData.tila.keikkaTilaId = 4;
  await keikkaData.tila.saveKeikkaTilaToDB(personId, token, true, socket, keikkaData.varmenne);

  const sl = newStepLogMessage("Tilaus vahvistettu ja on toimitusvalmis.", personId, keikkaData, 3);
  sl.isConfirmed = true;
  sl.confirmDate = new Date();
  sl.saveToDB(socket);
}

// muut toiminnot kun tallennetaan
export async function addStepLogMessage(
  keikkaData,
  socket,
  personId,
  txt, // joko string tai txt.body ja txt.title
  stepLogTypeId,
  addMessageOnlyIfVarmenneChanged = false,
  isSystemMessage = false,
  sendNotification = undefined,
  isConfirmed = false
) {
  if (keikkaData && keikkaData.tila.keikkaTilaId > 2) {
    // kirjaa viesti tietokantaan
    const stepLogNewMessage = newStepLogMessage(
      txt.body || txt,
      personId,
      keikkaData,
      stepLogTypeId
    );
    stepLogNewMessage.addMessageOnlyIfVarmenneChanged = addMessageOnlyIfVarmenneChanged;
    stepLogNewMessage.isSystemMessage = isSystemMessage;
    stepLogNewMessage.isConfirmed = isConfirmed;
    await stepLogNewMessage.saveToDB(socket);

    // jos toimitusvalmis (id=4) ja muutosviesti (id=13)
    const b1 =
      keikkaData.tila.muokkausTila &&
      (keikkaData.tila.origKeikkaTilaId == 4 || keikkaData.tila.origKeikkaTilaId == 5);
    const b2 = keikkaData.tila.keikkaTilaId == 4 || keikkaData.tila.keikkaTilaId == 5;

    if (
      sendNotification === true ||
      (stepLogTypeId == 13 && (b1 || b2) && sendNotification === undefined)
    ) {
      // lähetä PUSH viesti keikkakäyttäjille
      const title = txt.title || "Tilausmuutos";
      const body = txt.body || txt;

      await sendNotificationsToKeikkaUsers(
        {
          title: title,
          body: body,
          url: "/tilaus/" + keikkaData.keikkaId,
          keikkaId: keikkaData.keikkaId,
          personId: personId,
          icon: "/img/pumi.png",
          keikkaString: keikkaData.keikkaStringShort,
          ttl: calcTTL_s(keikkaData),
          collapseKey: keikkaData.keikkaId,
          priority: "high",
        },
        socket
      );
    }
  } else {
    // kun tilaus on kesken (id<3) ja stepLogTypeId=15 && !isConfirmed
    // Tarkistaa onko tilaustiedot täytetty ja merkitsee stepLogiin
    if (keikkaData && keikkaData.keikkaError() == null) {
      confirmStepLogType(keikkaData.keikkaId, 15, socket);
      const sl = newStepLogMessage(
        "Tilaustiedot täytetty, odottaa lähetystä.",
        personId,
        keikkaData,
        16
      );
      sl.addMessageOnlyIfVarmenneChanged = true;
      sl.requireConfirm = true;
      await sl.saveToDB(socket);
    }
  }
}

export async function saveKeikkaTilaToDB_exported(keikkaData, personId, token, socket) {
  await keikkaData.tila.saveKeikkaTilaToDB(personId, token, true, socket, keikkaData.varmenne);

  // send socket event
  const s = new socketOnSave(personId, socket, null, "keikkaData", "save", keikkaData.keikkaId);
  s.keikkaData = keikkaData;
  s.emitSave();

  await keikkaData.setAuthDataViaFetch(
    personId,
    keikkaData.keikkaId,
    keikkaData.tyomaaId,
    keikkaData.asiakas.asiakasId,
    keikkaData.tila.keikkaTilaId,
    token
  );
  return keikkaData;
}

export async function sendTilausvahvistus_exported(thisMail, keikkaData, personId, token, socket) {
  thisMail.confirmCode = uuidv4();
  thisMail.setButtonUrl();
  thisMail.sendTilausvahvistus(token);
  const sl = newStepLogMessage(
    "Tilausvahvistus lähetetty " + thisMail.emailToEmail,
    personId,
    keikkaData,
    20
  );
  sl.requireConfirm = true;
  sl.confirmCode = thisMail.confirmCode;
  sl.isSystemMessage = true;
  sl.saveToDB(socket);
}

export async function sendTilaustiedot_exported(thisMail, keikkaData, personId, token, socket) {
  // send tilausvahvistus
  thisMail.confirmCode = uuidv4();
  thisMail.setButtonUrl();
  const r = thisMail.sendTilaustiedot(token);
  const sl = newStepLogMessage(
    "Tilaustiedot lähetetty " + thisMail.emailToEmail,
    personId,
    keikkaData,
    4
  );
  sl.isSystemMessage = true;
  sl.requireConfirm = true;
  sl.confirmCode = thisMail.confirmCode;

  sl.saveToDB(socket);
  return r;
}

export async function sendTilausLuonnos_exported(thisMail, keikkaData, personId, token, socket) {
  // send tilausvahvistus
  thisMail.confirmCode = uuidv4();
  thisMail.setButtonUrl();
  thisMail.sendTilausLuonnos(token);
  const sl = newStepLogMessage(
    "Luonnos lähetetty " + thisMail.emailToEmail,
    personId,
    keikkaData,
    4
  );
  sl.requireConfirm = true;
  sl.confirmCode = thisMail.confirmCode;
  sl.isSystemMessage = true;
  sl.saveToDB(socket);
}

export function sendBetoniTilausToBetoniToimittaja(thisMail, keikkaData, personId, token, socket) {
  // send betonitilaus
  thisMail.confirmCode = uuidv4();
  thisMail.buttonUrl = "https://betoni.online/cc/" + thisMail.confirmCode;
  thisMail.sendBetoniTilaus(token);
  const sl = newStepLogMessage(
    "Betonitilaus lähetetty osoiteeseen " + thisMail.emailToEmail,
    personId,
    keikkaData,
    5
  );
  sl.isSystemMessage = true;
  sl.requireConfirm = true;
  sl.confirmCode = thisMail.confirmCode;
  sl.saveToDB(socket);
}

export async function sendPumiFiKapasiteetti(
  regNo,
  klo,
  huom,
  thisMail,
  token,
  personId,
  keikkaData,
  socket
) {
  const confirmCode = uuidv4();
  thisMail.confirmCode = confirmCode;
  thisMail.setButtonUrl();
  thisMail.sendKapasiteettiMuutos(token, regNo, klo, huom, keikkaData.keikkaId);
  const sl = newStepLogMessage(
    "Kapasiteettimuutos lähetetty " + thisMail.emailToEmail,
    personId,
    keikkaData,
    6
  );
  sl.isSystemMessage = true;
  sl.requireConfirm = true;
  sl.confirmCode = confirmCode;
  sl.saveToDB(socket);
}
export async function pumiFiCreatePalkki(keikkaData, regNo, txt, token, personId, socket) {
  // Create pumi.fi palkki
  const pumiFiApiData = pumiFiClass.getPumiFiCreateKeikkaData(keikkaData);
  pumiFiApiData.regNo = regNo;
  pumiFiApiData.poisTxt = txt;
  const a = await pumiFiClass.createPumiFiPalkki(pumiFiApiData, token);
  const sl = newStepLogMessage("Pumi.fi palkki luotu ", personId, keikkaData, 7);
  sl.isSystemMessage = true;
  sl.saveToDB(socket);
  return a;
}

export async function sendSMS_not_used(SMSToPuh, SMSTxt, token, personId, keikkaData, socket) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      msisdn: SMSToPuh,
      keikkaId: keikkaData.keikkaId,
      txt: SMSTxt,
      ownerAsiakasId: keikkaData.ownerAsiakasId,
    }),
  };
  fetch(import.meta.env.VITE_SERVER_URL + "/api/sendSMS/sendSMS", requestOptions);

  const sl = newStepLogMessage("SMS lähetetty " + SMSToPuh, personId, keikkaData, 14);
  sl.isSystemMessage = true;
  sl.saveToDB(socket);
}
